import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Award() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            「後世にのこしたい企業賞ｉｎ青森」を実施　本社などでつくる実行委　多様な媒体で広く発信
          </Typography>
          　デーリー東北新聞社は2026年度、創刊80周年記念事業として、青森県内の企業を対象とした「後世にのこしたい企業賞 ｉｎ 青森」を初めて実施します。<br />
          　本賞は、事業活動を通して地域で信頼を積み重ねてきた企業や、新たな価値の創造に挑む企業など「これから先も地域に残ってほしいと思える企業」に光を当て、広く発信することを目的としています。当社のほか、陸奥新報社（弘前市）、青森朝日放送（青森市）、採用ブランディングを手がけるインビジョン（東京）でつくる実行委員会が主催します。<br />
          　応募は社員や取引先、地域の関係者など当該企業に関わる方からの推薦制で、経営者本人による自薦は受け付けません。受付期間は5月13日から6月30日まで。<br />
          　書類審査や企業訪問を経て、▽大切にしている考え方や理念▽取り組みに表れている独自性▽働く人や組織の魅力―などを基準に総合的に判断します。27年2月に受賞企業を発表し、新聞、ウェブ、映像などで広く発信します。受賞企業には認定ロゴを付与します。<br />
          　詳細は公式サイト（URL：https://kosei-award.jp/、QRコード）をご覧ください。<br />
          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-kigyo/qr.jpg" className="img-fluid" /><br />
              </Grid>
            </Grid>
          </Box>
          　問い合わせは、デーリー東北新聞社地域ビジネス局内の本賞事務局＝電話0178（80）7095、平日午前10時～午後5時＝へ。
        </Box>

{/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3 text-white bg-dark rounded px-3 py-3" variant="subtitle1" component="div">
            第１回「頑張るあなたを応援する　デリオン賞」贈呈式（2022/03/11）
          </Typography>
          <img src="/images/award-delion/2022-top-min.jpg" className="float-img float-md-left mx-md-3 my-3" />
          　デーリー東北新聞社は１０日、地域貢献や将来性が期待される活動に取り組む北奥羽地方ゆかりの個人・団体をたたえ、エールを送る「第１回頑張るあなたを応援するデリオン賞」の贈呈式を八戸市のデーリー東北ホールで開いた。受賞者は、受賞の喜びを胸に、各分野でのさらなる飛躍を誓った。<br/>
          <br/>
          　デリオン賞は、さまざまな分野で輝かしい功績のあった北奥羽ゆかりの個人・団体を表彰する「デーリー東北賞」が２０２１年で５０回目の節目を迎えたのを記念して、同年１２月に新設した。<br/>
          <br/>
          　記念すべき第１回の受賞者は、ユニークなポップで本や書店の魅力を発信する及川晴香さん（３３）＝八戸市＝、スポーツクライミングで全国を舞台に活躍する関川愛音（めろでぃ）さん（１４）＝同＝、農家支援と地域おこしに取り組む合同会社「南部どき」＝南部町＝の２個人１団体。<br/>
          <br/>
          　式では、デーリー東北新聞社の荒瀬潔社長が及川さん、関川さん、「南部どき」代表の根市大樹さん（４０）に賞状と副賞を授与し、同社の公式マスコットキャラクター「デリオン」と共に記念撮影した。<br/>
          <br/>
          　受賞後のあいさつでは、及川さんが「受賞を励みに、今後も地域の皆さまに楽しんでもらえるアイデアを出していきたい」と決意新た。関川さんは「ユース（世代別）だけでなく、シニアの大会でも好成績を残す」と飛躍を誓った。根市さんは「地域農業の課題を解決できるよう努力し、地域と共に会社を発展させたい」と抱負を語った。<br/>
          <br/>
          　荒瀬社長は「地元を活気づけるためには、元気な人の活動を知らしめることが必要。今後ますますの活躍を期待している」と激励した。<br/>
          <br/>
          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-delion/2022-oikawa-min.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold mb-4" variant="h6" component="div">
                  及川　晴香（おいかわ・はるか）<br />
                </Typography>
                <div className="font-weight-bold mb-4">
                  １９８８年５月、八戸市生まれ。２０１１年、木村書店入社。１７年から、同店のオリジナルキャラクター「きむねこ」が登場するポップを製作。現在、本紙ヤング面で「木村書店ポプ担のあの本この本読んでやあんせ」を連載中。
                </div>
                　八戸市小中野８丁目に店を構え、９０年の歴史を持つ木村書店は近年、「ポップごと売る本屋さん」として、全国から注目を集めている。その立役者がポップ担当の及川さん。ツイッターアカウントでは、書籍の紹介と書店員の日常をつづった漫画を投稿しており、フォロワーは２万５千人超え。アナログとデジタルの両方の手法で、地方の小さな書店や本の魅力を全国に発信している。「ポプ担」の愛称で親しまれ、２０２１年には３年分のポップをまとめた「青森の八戸にある小さな本屋さんの猫がかわいいポップの本」を小学館から出版した。
              </Grid>
            </Grid>
          </Box>

          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-delion/2022-sekikawa-min.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold mb-4" variant="h6" component="div">
                  関川　愛音（せきかわ・めろでぃ）<br />
                </Typography>
                <div className="font-weight-bold mb-4">
                  ２００７年７月生まれ。八戸市出身。市立湊小 湊中２年。ボルダリングのユース日本選手権の成績は、２０年にユースＣ（１２、１３歳）優勝、２１年は同Ｂ（１４、１５歳）で準優勝。来春からは市内の私立高校で競技を続ける予定。身長１６１センチ
                </div>
                　人工の壁面に設けられた「ホールド」と呼ばれる課題を手足などの力でクリアしていくスポーツクライミング。この競技の世代別（ユース）日本代表で、世界大会での活躍が期待されている。長い手足と体幹の強さを武器にジュニア世代の大会で常に好成績を収め、シニア顔負けの実力を誇る。１５歳になる今年からは、五輪代表選手選考につながる国内大会「ジャパンカップ」への参戦が可能になる。もちろん、２４年のパリ五輪も視界に入っており、「夢は五輪で金メダル」と志は高い。「この一年が勝負の年」。世界に羽ばたく日は近づいている。
              </Grid>
            </Grid>
          </Box>

          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-delion/2022-neichi-min.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold mb-4" variant="h6" component="div">
                  根市　大樹（ねいち・ひろき）<br />
                </Typography>
                <div className="font-weight-bold mb-4">
                  １９８１年６月、南部町（旧名川町）生まれ。青森県立八戸高 大阪芸術大文芸学部卒。デーリー東北新聞社を退職後、２０１２年にＮＰＯ法人の立ち上げに参画。１６年、合同会社「南部どき」を設立。１８年、同町大向に同名のカフェを開店した。
                </div>
                　地元にあふれる資源に着目し、次々と地域活性化のためのアイデアを打ち出している合同会社「南部どき」（南部町）。魅力ある地域や子どもたちに誇れる〝ふるさと〟を残したいと日々、奔走している。代表の根市さんはオーストラリアへの農業留学などを経て、帰国後、地産地消をコンセプトにした飲食店を開店。シェフの弟が腕を振るうレストランは人気を呼び、農産物の新たな販路を生み出した。地元でのＮＰＯ法人立ち上げのほか、処分されてきた果樹の剪定（せんてい）枝を食品の薫製に活用したり、地元駅前にカフェを開店したりと、精力的に活動を続けている。
              </Grid>
            </Grid>
          </Box>
        </Box>
*/}
        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            これまでの受賞者
          </Typography>
          <Box my={4} textAlign="left">
            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第５０回（令和３年度）</dt>
                  <dd>
                    栗村　知弘氏<br/>
                    青森県立八戸西高等学校文芸部<br/>
                    青森県立八戸高等学校文芸部<br/>
                    デーリー東北特別賞（令和３年）<br/>
                    天摩　由貴氏<br/>
                  </dd>
                </dl>
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}
      </div>
    </div>
  );
}

export default Award;
